import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';

import 'App.css';
import CloseButton from 'Common/CloseButton/CloseButton';
import Page from 'Common/Layout/Page';
import Menu from './Views/MenuView/Menu.view';
import PreEx6 from './Views/PreEx6/PreEx6.view';
import AmendContract from './Views/AmendContract/AmendContract.view';
import PostEx6 from './Views/PostEx6/PostEx6.view';
import classes from './ContractHeader.module.css';

const MarkersContractReleaseContainer = props => {
	const [active_menu, setActiveMenu] = useState(props.location.state?.active || '');

	const handleActiveMenu = (menuToOpen = '') => setActiveMenu(menuToOpen);

	switch (active_menu) {
		case 'pre_ex6':
			return (
				<>
					<PreEx6 handleActiveMenu={handleActiveMenu} />
					<span className={classes['action-buttons']}>
						<CloseButton closeOnClick={handleActiveMenu} />
					</span>
				</>
			);
		case 'amend_contract':
			return (
				<>
					<AmendContract />
					<span className={classes['action-buttons']}>
						<CloseButton closeOnClick={handleActiveMenu} />
					</span>
				</>
			);
		case 'post_ex6':
			return (
				<>
					<PostEx6 />
					<span className={classes['action-buttons']}>
						<CloseButton closeOnClick={handleActiveMenu} />
					</span>
			</>
			);
		default:
			return (
				<>
					<Page title="Release Management">
					</Page>
					<Menu handleActiveModal={handleActiveMenu} />
					{/* <ModalFactory title={active_title} activeModal={active_menu} handleClose={handleActiveMenu} /> */}
				</>
			);
	}
};

export default MarkersContractReleaseContainer;
